import { render, staticRenderFns } from "./table-list.vue?vue&type=template&id=6a4e2474&"
import script from "./table-list.vue?vue&type=script&lang=ts&"
export * from "./table-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports